module.exports = new __parcel__URL__("news04.c544e39a.jpg").toString();